import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumb } from "antd";

const Breadcrumbs = () => {
  const { pathname } = useLocation();

  const segments = pathname.split("/").filter(Boolean);

  // Remove "admin" from visual segments and "dashboard" to avoid duplication with root
  const filteredSegments = segments.filter(seg => seg !== "admin" && seg !== "dashboard");

  const breadcrumbItems = [
    {
      key: 'home',
      title: (
        <Link
          to="/dashboard"
          className="!collapsetext-secondary hover:!text-primary no-underline text-base transition-colors"
        >
          Dashboard
        </Link>
      )
    }
  ];

  const pathSegments = filteredSegments.map((segment, index) => {
    const isLast = index === filteredSegments.length - 1;

    const label = segment
      .replace(/-/g, " ")
      .replace(/\b\w/g, l => l.toUpperCase());

    // Assuming flat admin routes structure based on previous code
    const path = `/admin/${segment}`;

    return {
      key: path,
      title: isLast ? (
        <span className="!text-primary font-medium text-base">
          {label}
        </span>
      ) : (
        <Link
          to={path}
          className="!collapse text-secondary hover:!text-primary !no-underline text-base transition-colors hover:!bg-transparent"
        >
          {label}
        </Link>
      )
    };
  });

  const allItems = [...breadcrumbItems, ...pathSegments];

  // Only hide if we are basically at root/dashboard (length 1)
  // But strictly, even on dashboard it might be nice to show just "Dashboard". 
  // However current logic returns null.
  // If user is at /dashboard, filteredSegments is empty. items len = 1.
  // User asked for "breadcrumbs not getting showed" on a sub page. 
  // Logic: if we are at root, maybe hide?
  // Let's hide if length is 1 (Dashboard only).
  if (allItems.length <= 1) return null;

  return (
    <div className="px-6">
      <Breadcrumb
        items={allItems}
        separator={<span className="mx-2 text-secondary">/</span>}
      />
    </div>
  );
};

export default Breadcrumbs;
